module.exports = __webpack_public_path__ + "img/doppler_emerald.18977f27.svg";